import { useAuth } from "@/features/auth/auth-context";
import { Button, Card, CardBody, Input } from "@heroui/react";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setError(null);
    setIsSubmitting(true);
    try {
      await login(username, password);
      navigate({ to: "/" });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <Card className="w-full max-w-md">
        <CardBody className="space-y-4 p-6">
          <div>
            <h1 className="text-2xl font-semibold">Sign in</h1>
            <p className="text-foreground-500 text-sm">
              Authenticate to access your downloads and playlists.
            </p>
          </div>
          <Input
            label="Username"
            value={username}
            onValueChange={setUsername}
            autoComplete="username"
          />
          <Input
            label="Password"
            type="password"
            value={password}
            onValueChange={setPassword}
            autoComplete="current-password"
          />
          {error ? <p className="text-danger text-sm">{error}</p> : null}
          <Button color="primary" onPress={handleSubmit} isLoading={isSubmitting}>
            Sign in
          </Button>
        </CardBody>
      </Card>
    </div>
  );
}
